export default __webpack_public_path__ + "static/media/img3.7adf9e5f.jpg";